<template>
  <div class="login-view">
    <login-form
      @onError="onError"
      @onSubmit="onSubmit"
    />
  </div>
</template>

<script>
import LoginForm from '@/modules/login/login-form'
import AuthService from '@/services/auth.service'

export default {
  name: 'LoginView',
  components: { LoginForm },
  data () {
    return {
      hasError: false
    }
  },
  methods: {
    onError () {
      this.hasError = true
      setTimeout(() => {
        this.hasError = false
      }, 1500)
    },
    onSubmit (model) {
      AuthService.authenticate(model.username, model.password, model.rememberMe)
        .then((response) => {
          console.log('redirect URL', response)
          this.$router.push(AuthService.redirectURL)
          AuthService.redirectURL = null
        })
        .catch(e => {
          switch (e.response.status) {
            case 401:
              this.$notify.error({message: 'Usuarios o Contraseña incorrecto', title: 'Revisar los campos'})
              break
            case 429:
              this.$notify.warning({message: 'Demasiados intentos de ingreso', title: 'Espere unos minutos'})
              break
          }
          this.hasError = true
          this.$emit('onError', this.hasError)
        })
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .login-view {

  }

</style>



// WEBPACK FOOTER //
// src/views/login/login-view.vue